export default __webpack_public_path__ + "static/area-eb6ac882c5c7c95acb269bb62364c448.png";